import * as React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";

const formatTime = (sec) => {
  const m = String(Math.floor(sec / 60)).padStart(2, "0");
  const s = String(sec % 60).padStart(2, "0");
  return `${m}:${s}`;
};

export default function ReportLoadingDialog({
  open,
  title,
  subtitle,
  showTimer = true,
}) {
  const [elapsed, setElapsed] = React.useState(0);

  // Reset when dialog opens
  React.useEffect(() => {
    if (open) setElapsed(0);
  }, [open]);

  // Start timer
  React.useEffect(() => {
    if (!open) return;

    const t = setInterval(() => {
      setElapsed((s) => s + 1);
    }, 1000);

    return () => clearInterval(t);
  }, [open]);

  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          py={3}
        >
          <CircularProgress size={42} />

          <Typography
            variant="body1"
            fontWeight={600}
            align="center"
            sx={{ mt: 2 }}
          >
            {title}
          </Typography>

          {subtitle && (
            <Typography
              variant="caption"
              color="text.secondary"
              align="center"
              sx={{ mt: 0.5 }}
            >
              {subtitle}
            </Typography>
          )}

          {showTimer && (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mt: 1 }}
            >
              Running for {formatTime(elapsed)}
            </Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
